export default __webpack_public_path__ + "static/media/e1bd.6db70e24.svg";